import {Form} from "react-bootstrap";
import SelectGridWithIcon from "../../../../ui/select/SelectGridWithIcon";
import {Link} from "react-router-dom";
import React from "react";
import MainButton from "../../../../ui/forms/Buttons";

const SelectProfessionStep = props => {
    const formHeaderText = 'Please Select Your Profession';
    const signInText = 'Sign In';
    const nextText = 'Next';

    const {options, value, onNextClick, onSelect} = props;

    return (
        <Form className="select-profession-step sign-up-form">
            <Form.Group>
                <Form.Text className="form--header"> {formHeaderText} </Form.Text>
                <SelectGridWithIcon aspectRatio={4. / 3} options={options} defaultValue={value} onChange={onSelect}/>
                <MainButton color="primary" size="xl" text={nextText} className="w-100" onClick={onNextClick}/>

                <div className="sign-in-section mb-0 text-center">
                    <p>Already have an account?</p>
                    <Link to="/signin">{signInText}</Link>
                </div>
            </Form.Group>
        </Form>
    );
};

export default SelectProfessionStep;
